// RestaurantOrderFields.js
// Field name constants mapped 1:1 to the real fieldName values returned by
// the process definition API (processNum "003", stageSequence 0).
// Using named constants instead of positional `keys[N]` indexing (as
// LeaveRequest.js does) so the JSX doesn't break if field order changes.

export const F = {
    REQUESTED_FOR:      'field_003001000001',
    REQUEST_DATE:       'field_003001000002',
    ORDER_NUMBER:       'field_003001000003',
    BRANCH:             'field_003001000004',
    ORDER_TYPE:         'field_003001000005',
    ORDER_STATUS:       'field_003001000006',
    WAITER:             'field_003001000007',
    CASHIER:            'field_003001000008',
    SHIFT:              'field_003001000009',
    TOKEN_NUMBER:       'field_003001000010',
    DELIVERY_DATE:       'field_003001000081',
    EXPECTED_DELIVERY_TIME:       'field_003001000082',

    TABLE_INFO:         'field_003001000011',
    TABLE_NUMBER:       'field_003001001012',
    TABLE_SUB_CODE:     'field_003001001013',
    NO_OF_GUESTS:       'field_003001001014',
    ADULT_COUNT:        'field_003001001015',
    CHILD_COUNT:        'field_003001001016',
    RESERVATION_NO:     'field_003001001017',
    TABLE_STATUS:       'field_003001001018',

    CUSTOMER_INFO:      'field_003001000019',
    CUST_NAME:          'field_003001002020',
    CUST_MOBILE:        'field_003001002021',
    CUST_MEMBERSHIP_NO: 'field_003001002022',
    CUST_GST:           'field_003001002023',
    CUST_REMARKS:       'field_003001002024',

    DELIVERY_ADDRESS:   'field_003001000025',
    DEL_ADDRESS:        'field_003001003026',
    DEL_LANDMARK:       'field_003001003027',
    DEL_GOOGLE_LOC:     'field_003001003028',
    DEL_BUILDING:       'field_003001003029',
    DEL_FLOOR:          'field_003001003030',
    DEL_DOOR_NO:        'field_003001003031',

    DELIVERY_INFO:      'field_003001000032',
    DEL_BOY:            'field_003001004033',
    DEL_CHARGE:         'field_003001004034',
    DEL_EXPECTED_TIME:  'field_003001004035',
    DEL_DISTANCE:       'field_003001004036',
    DEL_STATUS:         'field_003001004037',
    DEL_OTP:            'field_003001004038',
    DEL_INSTRUCTIONS:   'field_003001004039',

    MENU_ITEMS:         'field_003001000040',
    MI_ITEM:            'field_003001005041',
    MI_QTY:             'field_003001005042',
    MI_UOM:             'field_003001005043',
    MI_RATE:            'field_003001005044',
    MI_DISCOUNT_PCT:    'field_003001005045',
    MI_TAX_PCT:         'field_003001005046',
    MI_NET_AMOUNT:      'field_003001005047',
    MI_KITCHEN:         'field_003001005048',
    MI_SPECIAL_INSTR:   'field_003001005049',
    MI_KOT_STATUS:      'field_003001005050',
    MI_SERVED_QTY:      'field_003001005051',
    MI_CANCELLED_QTY:   'field_003001005052',
    MI_PREPARED_QTY:    'field_003001005053',
    MI_BALANCE_QTY:     'field_003001005054',
    MI_MODIFIER_SEL:    'field_003001005055',
    MI_ORDERED_BY:      'field_003001005080',

    KOT_INFO:           'field_003001000056',
    KOT_NUMBER:         'field_003001006057',
    KOT_KITCHEN:        'field_003001006058',
    KOT_MENU_ITEM:      'field_003001006059',
    KOT_STATUS:         'field_003001006060',

    BILL_SUMMARY:       'field_003001000061',
    BILL_GROSS:         'field_003001007062',
    BILL_ITEM_DISCOUNT: 'field_003001007063',
    BILL_DISCOUNT:      'field_003001007064',
    BILL_TAX:           'field_003001007065',
    BILL_SERVICE_CHG:   'field_003001007066',
    BILL_PACKING_CHG:   'field_003001007067',
    BILL_DELIVERY_CHG:  'field_003001007068',
    BILL_ROUND_OFF:     'field_003001007069',
    BILL_GRAND_TOTAL:   'field_003001007070',

    PAYMENT_INFO:       'field_003001000071',
    PAY_TYPE:           'field_003001008072',
    PAY_AMOUNT_TENDERED:'field_003001008073',
    PAY_CHANGE_RETURN:  'field_003001008074',
    PAY_TRANSACTION_NO: 'field_003001008075',
    PAY_CARD_NO:        'field_003001008076',
    PAY_BANK:           'field_003001008077',
    PAY_APPROVAL_NO:    'field_003001008078',
    PAY_STATUS:         'field_003001008079',
};

// Strip the 'field_' prefix to get the raw fieldName the backend expects
// in RequestAttributes payloads (matches LeaveRequest.js's removeString()).
export const raw = (fieldConst) => fieldConst.replace('field_', '');
